<template>
  <div class="d-flex pb-4 justify-space-between" style="width: 100%;">
    <h2
      class="align-self-center"
    >
      <BaseSectionTitle disable-padding :title="fullTitle" />
    </h2>

    <BaseDialog
      v-model="dialog"
      v-if="hasInfo"
      :max-width="$vuetify.breakpoint.thresholds.xs"
      v-bind="$attrs"
      v-on="$listeners"
      :continueText="$t('buttons.confirm')"
      @continue="dialog = false"
      :title="$t('general.timelines.status_information')"
    >
      <template #activator="{ attrs, on }">
        <v-btn
          icon
          text
          color="primary"
          v-bind="attrs"
          v-on="on"
          class="mr-n2 align-self-center"
          large
        >
        <v-icon color="currentColor">mdi-information-outline</v-icon>
        </v-btn>
      </template>
      <template #content>
        <slot name="info" />
      </template>
    </BaseDialog>
  </div>
</template>

<script>
import { capitalize } from 'lodash';

export default {
  props: {
    title: {
      type: String,
      required: true,
      default: '',
    },
    prefix: {
      type: String,
      default: '',
    },
    suffix: {
      type: String,
      default: '',
    },
    disableCaps: {
      type: [Boolean, Array],
      default: false,
      validate: v => {
        if (typeof v === 'boolean') return true;
        if (Array.isArray(v)) {
          const options = ['prefix', 'suffix', 'title'];
          return v.reduce((arr, option) => arr && options.includes(option));
        }
        return false;
      },
    },
    filterTitle: {
      type: Boolean,
      default: false,
    },
  },
  metaInfo() {
    return {
      title: this.title,
    };
  },
  computed: {
    hasInfo() {
      return !!this.$scopedSlots.info;
    },
    fullTitle() {
      const str = '';
      const { prefix, title, suffix, disableCaps } = this;
      let text = { prefix, title, suffix };

      if (!disableCaps) {
        if (Array.isArray(disableCaps)) {
          disableCaps.forEach(key => (text[key] = capitalize(text[key])));
        } else {
          Object.keys(text).forEach(key => (text[key] = capitalize(text[key])));
        }
      }

      if (text.prefix) {
        text.prefix = text.prefix + ' - ';
      }
      if (text.suffix) {
        text.suffix = ' - ' + text.suffix;
      }

      return str.concat(...Object.values(text));
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    capitalize,
  },
};
</script>
